module.exports = __webpack_public_path__ + "static/img/bg_item_6.07dc9ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/bg_item_6.png
// module id = P1CV
// module chunks = 1